const Siparis = resolve => {
    require.ensure(['../views/apps/siparis/Siparis'], () => {
        resolve(require('../views/apps/siparis/Siparis'))
    })
};

const SiparisListesi = resolve => {
    require.ensure(['../views/apps/siparis/SiparisListesi'], () => {
        resolve(require('../views/apps/siparis/SiparisListesi'))
    })
};


import layouts from '../layout'

export default {
    path: '/siparis',
    name: 'siparis',
    component: Siparis,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'liste',
            name: 'siparisListesi',
            component: SiparisListesi,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
    ],

}
